import { Box } from '@mui/material';

import { useMediaQuery } from 'shared/hooks/dom';

import { Avatar } from './components/Avatar';
import { AVATAR_SIZE } from './components/Avatar/constants';
import { Wrapper } from './components/Wrapper';

import type { BoxProps } from '@mui/material';
import type { FC, PropsWithChildren, ReactNode } from 'react';

interface BaseMessageProps extends PropsWithChildren {
  avatarContent: ReactNode;
  sx?: BoxProps['sx'];
}

export const BaseMessage: FC<BaseMessageProps> = ({
  avatarContent,
  children,
  ...props
}) => {
  const matches = useMediaQuery('md', 'down');

  return (
    <Wrapper {...props}>
      {!matches && avatarContent && (
        <Box sx={{ width: AVATAR_SIZE }}>
          <Avatar>{avatarContent}</Avatar>
        </Box>
      )}
      {children}
    </Wrapper>
  );
};
